import React, { Component } from "react";
import Swal from "sweetalert2";
import {
  Button,
  Modal,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Tooltip,
  IconButton,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Checkbox,
  Dialog,
  CircularProgress,
  DialogContent,
} from "@material-ui/core";
import { navigate } from "../../actions/routerResolve";
import { connect } from "react-redux";
import { msgSimple } from "../../actions/snackbarActions";
import moment from "moment";
import ColorService from "../../tools/ColorsService";
import ArrowForward from "@material-ui/icons/ArrowForward";
import Edit from "@material-ui/icons/Edit";
import CheckCircle from "@material-ui/icons/CheckCircle";
import {
  isVooLiberado,
  MISSION_STATUS,
  MissionStatusAuthorized,
  MissionStatusGeneral,
  MissionStatusNotAuthorized,
  MissionStatusOptionToChange,
  StageFinishedStatus,
  StageNotFinishedStatus,
  StatusToConfirm,
} from "../../enums";
import { Forward, GestureTwoTone, Group } from "@material-ui/icons";
import { colors } from "../../styles";
import FlightStageService from "../../tools/FlightStageService";
import withReactContent from "sweetalert2-react-content";
import passengers from "../settings/passengers";
import { getStatus } from "../../enums";

const MySwal = withReactContent(Swal);

class ModalStatus extends Component {
  constructor(props) {
    super(props);
    this.state = {
      stages: this.props.stages || [],
      actualStatus: this.props.status,
      missionName: this.props.modal.missionName || "Não definido",
      selectedStatus: this.props.status || "Solicitado",
      createdBy: this.props.createdBy || {},
      allPermission: this.props.allPermission || false,
      statusMission: this.props.statusMission || "",
      openStatusModal: false,
      openPassengersModal: false,
      currentStage: {},
      missionId: this.props.missionId || "",
    };
  }

  handleUpdateStatusMission = (newStatus, showConfirmation = true) => {
    this.setState({ statusMission: newStatus });
    this.props.handleUpdateStatusMission(newStatus, showConfirmation);
  };

  handleAuthorizeStage = (stage) => {
    Swal.fire({
      title: "Deseja realmente alterar essa etapa?",
      type: "info",
      customClass: "{ z-index: 1000000 }",
      customContainerClass: "{ z-index: 100000 }",
      showCloseButton: true,
      showCancelButton: true,
      focusConfirm: false,
      confirmButtonText: '<i class="fa fa-thumbs-up"></i> Sim',
      confirmButtonAriaLabel: "Sim",
      cancelButtonText: '<i class="fa fa-thumbs-down"></i> Não',
      cancelButtonAriaLabel: "Não",
    }).then(async (result) => {
      if (result.value) {
        if (stage.status !== MISSION_STATUS.AUTORIZADO) {
          stage.status = MISSION_STATUS.AUTORIZADO;
        } else {
          stage.status = MISSION_STATUS.CONFIRMADO;
        }

        stage.authorized = true;
        this.setState({ loading: true });
        const stageCopy = {
          ...stage,
        };
        if (stageCopy.passengers) {
          stageCopy.passengers = stage.passengers.map((item) => item.id);
        }
        FlightStageService.update(stage.id, stageCopy).then((result) => {
          this.setState({ loading: false });
          if (result.ok) {
            MySwal.fire({
              title: "<p>Status salvo com sucesso!</p>",
              type: "success",
            });
            // this.setState({ openStatusModal: false });
          } else {
            MySwal.fire({
              title: "<p>Erro ao salvar Status!</p>",
              type: "error",
            });
          }
        });
      }
    });
  };

  handleAlterarStatus = (stage) => {
    console.log(stage);
    this.setState({ openStatusModal: true, currentStage: stage });
  };

  handleCloseStatusModal = () => {
    this.setState({ openStatusModal: false });
  };

  handlePassengersModal = (stage) => {
    console.log("stage: ", stage);
    this.setState({ openPassengersModal: true, currentStage: stage });
  };

  handleClosePassengersModal = () => {
    this.setState({ openPassengersModal: false });
  };

  handleSaveNewStatusStage = (status, stage) => {
    console.log(stage);
    Swal.fire({
      title: `Deseja realmente alterar o status da etapa, de ${stage.status} para ${status}?`,
      type: "info",
      customClass: "{ z-index: 1000000 }",
      customContainerClass: "{ z-index: 100000 }",
      showCloseButton: true,
      showCancelButton: true,
      focusConfirm: false,
      confirmButtonText: '<i class="fa fa-thumbs-up"></i> Sim',
      confirmButtonAriaLabel: "Sim",
      cancelButtonText: '<i class="fa fa-thumbs-down"></i> Não',
      cancelButtonAriaLabel: "Não",
    }).then(async (result) => {
      if (result.value) {
        this.state.currentStage.status = status;
        this.setState({ loading: true });
        const stageCopy = {
          ...stage,
        };
        if (stageCopy.passengers) {
          stageCopy.passengers = stage.passengers.map((item) => item.id);
        }

        const thereIsNoStageOpenned = this.state.stages.filter((stage) =>
          StageNotFinishedStatus.includes(stage.status)
        );

        const containsStageInProgress = this.state.stages.filter((stage) =>
          [...MissionStatusAuthorized, ...StatusToConfirm].includes(
            stage.status
          )
        );

        if (
          !thereIsNoStageOpenned.length &&
          StageFinishedStatus.includes(status)
        ) {
          console.log("Changing mission status");
          this.handleUpdateStatusMission(status, false);
        } else if (containsStageInProgress.length) {
          this.handleUpdateStatusMission(MISSION_STATUS.EM_ANDAMENTO, false);
        }

        FlightStageService.update(stage.id, stageCopy).then((result) => {
          this.setState({ loading: false });
          if (result.ok) {
            MySwal.fire({
              title: "<p>Status salvo com sucesso!</p>",
              type: "success",
            });
            this.handleCloseStatusModal();
          } else {
            MySwal.fire({
              title: "<p>Erro ao salvar Status!</p>",
              type: "error",
            });
          }
        });
      }
    });
  };

  render() {
    return (
      <div>
        <Dialog open={this.state.loading}>
          <DialogContent>
            <CircularProgress></CircularProgress>
          </DialogContent>
        </Dialog>
        <Modal
          open={this.props.openModal || false}
          onClose={this.props.closeStatusModal}
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <div
            style={{
              background: "white",
              borderRadius: 8,
              padding: 20,
              width: "90%",
              maxHeight: "90vh",
              overflowY: "auto",
              boxShadow: "0 4px 20px rgba(0, 0, 0, 0.2)",
            }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "start",
                flexWrap: "wrap",
                gap: 16,
              }}
            >
              <div>
                <p
                  style={{
                    margin: 6,
                    fontSize: 18,
                  }}
                >
                  Etapas de {this.state.missionName}
                </p>
                <p style={{ marginLeft: 8 }}>
                  {this.state.createdBy.first_name &&
                    `Solicitado por ${this.state.createdBy.first_name}`}
                </p>
              </div>
              <div
                style={{
                  marginRight: 10,
                  padding: 10,
                  backgroundColor: colors.lighter,
                  borderRadius: 10,
                }}
              >
                <FormControl style={{ minWidth: 250 }}>
                  <InputLabel>Status Geral Missão:</InputLabel>
                  <Select
                    value={this.state.statusMission}
                    onChange={(value) =>
                      this.handleUpdateStatusMission(value.target.value)
                    }
                  >
                    {MissionStatusGeneral.map((status) => (
                      <MenuItem key={status} value={status}>
                        {getStatus(status)}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </div>
            </div>
            <br></br>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell style={tableStyle}></TableCell>
                  <TableCell style={tableStyle}>ORIGEM</TableCell>
                  <TableCell style={tableStyle}>DESTINO</TableCell>
                  <TableCell style={tableStyle}>DECOLAGEM</TableCell>
                  <TableCell style={tableStyle}>CHEGADA</TableCell>
                  <TableCell style={tableStyle}>STATUS</TableCell>
                  <TableCell style={tableStyle}>QTD PAX</TableCell>
                  <TableCell style={tableStyle}>DETALHES</TableCell>
                  <TableCell></TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {(this.state.stages || [])
                  .sort((a, b) => {
                    const dateA = a.departure_date
                      ? moment(a.departure_date)
                      : moment(0);
                    const dateB = b.departure_date
                      ? moment(b.departure_date)
                      : moment(0);

                    const timeA = a.local_time ? a.local_time : "00:00";
                    const timeB = b.local_time ? b.local_time : "00:00";

                    const dateTimeA = dateA.set({
                      hour: parseInt(timeA.split(":")[0]),
                      minute: parseInt(timeA.split(":")[1]),
                    });

                    const dateTimeB = dateB.set({
                      hour: parseInt(timeB.split(":")[0]),
                      minute: parseInt(timeB.split(":")[1]),
                    });

                    return dateTimeA - dateTimeB;
                  })
                  .map((el, index) => {
                    return (
                      <TableRow
                        className="table-row"
                        style={{ fontSize: 16 }}
                        key={index}
                      >
                        <TableCell>{index + 1}</TableCell>
                        <TableCell>{el.from || "N/A"}</TableCell>
                        <TableCell>{el.to || "N/A"}</TableCell>
                        <TableCell>
                          {el.departure_date
                            ? moment(el.departure_date)
                                .format("DD/MMM/YYYY")
                                .toUpperCase()
                            : "--/--/--"}
                          {"  "}
                          às{"  "}
                          {el.local_time
                            ? `${el.local_time.split(":")[0]}:${
                                el.local_time.split(":")[1]
                              }`
                            : "-- : --"}
                        </TableCell>
                        <TableCell>
                          {el.arrival_date
                            ? moment(el.arrival_date)
                                .format("DD/MMM/YYYY")
                                .toUpperCase()
                            : "--/--/--"}
                          {"  "}
                          às{"  "}
                          {el.arrival_time
                            ? `${el.arrival_time.split(":")[0]}:${
                                el.arrival_time.split(":")[1]
                              }`
                            : "-- : --"}
                        </TableCell>
                        <TableCell>
                          <span
                            style={{
                              fontSize: 14,
                              padding: "1px 4px",
                              backgroundColor: ColorService.backgroundColor(
                                el.status
                              ),
                              color: ColorService.contrastColor(el.status),
                              borderRadius: 4,
                            }}
                          >
                            {getStatus(el.status)}
                          </span>
                        </TableCell>
                        <TableCell>{el.passengers.length}</TableCell>
                        <TableCell>{isVooLiberado(el.status)}</TableCell>
                        <TableCell>
                          <div style={{ display: "flex" }}>
                            {this.state.allPermission &&
                              (MissionStatusNotAuthorized.includes(el.status) ||
                                el.status === MISSION_STATUS.AUTORIZADO) && (
                                <Tooltip
                                  title={
                                    el.status === MISSION_STATUS.AUTORIZADO
                                      ? "AUTORIZAÇÃO 2"
                                      : "AUTORIZAÇÃO 1"
                                  }
                                >
                                  <IconButton
                                    color="inherit"
                                    onClick={() =>
                                      this.handleAuthorizeStage(el)
                                    }
                                  >
                                    <CheckCircle fontSize="small" />
                                  </IconButton>
                                </Tooltip>
                              )}
                            {el.status !== MISSION_STATUS.AUTORIZADO && (
                              <Tooltip title="ALTERAR STATUS">
                                <IconButton
                                  onClick={() => this.handleAlterarStatus(el)}
                                >
                                  <Edit fontSize="small" />
                                </IconButton>
                              </Tooltip>
                            )}
                            <Tooltip title="PASSAGEIROS">
                              <IconButton
                                onClick={() => this.handlePassengersModal(el)}
                              >
                                <Group fontSize="small" />
                              </IconButton>
                            </Tooltip>
                          </div>
                        </TableCell>
                      </TableRow>
                    );
                  })}
              </TableBody>
            </Table>
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                marginTop: 16,
              }}
            >
              {/* <Button
            onClick={() =>
              this.props.handleSave(this.state.selectedStatus, this.state.id)
            }
            variant="contained"
            color="primary"
            style={{ marginRight: 8 }}
          >
            Salvar
          </Button> */}
              <Button onClick={this.props.closeStatusModal} color="secondary">
                Fechar
              </Button>
              <Tooltip title="DETALHAR MISSÃO">
                <Button
                  style={{ marginBottom: 4 }}
                  onClick={() => {
                    if (this.state.missionId) {
                      this.props.navigate("/flight/" + this.state.missionId);
                    }
                  }}
                >
                  Detalhar missão
                </Button>
              </Tooltip>
            </div>
          </div>
        </Modal>

        <Modal
          open={this.state.openStatusModal}
          onClose={this.handleCloseStatusModal}
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <div
            style={{
              background: "white",
              borderRadius: 8,
              padding: 20,
              width: "30%",
              maxHeight: "auto",
              overflowY: "auto",
              boxShadow: "0 4px 20px rgba(0, 0, 0, 0.2)",
            }}
          >
            <h2 style={{ margin: 0 }}>Alterar Status</h2>
            <br></br>
            <Table>
              {/* <TableHead>
                <TableRow>
                  <TableCell>Status</TableCell>
                </TableRow>
              </TableHead> */}
              <TableBody>
                {(MissionStatusAuthorized.includes(
                  this.state.currentStage.status
                ) || StatusToConfirm.includes(this.state.currentStage.status)
                  ? MissionStatusAuthorized
                  : MissionStatusNotAuthorized
                ).map((status, index) => (
                  <TableRow key={index}>
                    <TableCell
                      onClick={() => {
                        if (status === this.state.currentStage.status) return;
                        this.handleSaveNewStatusStage(
                          status,
                          this.state.currentStage
                        );
                      }}
                      style={{
                        borderRadius: 10,
                      }}
                    >
                      <Checkbox
                        value={status}
                        title={status}
                        checked={status === this.state.currentStage.status}
                        style={{ color: "black" }}
                      ></Checkbox>
                      <span>{status}</span>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                marginTop: 16,
              }}
            >
              <Button onClick={this.handleCloseStatusModal} color="secondary">
                Fechar
              </Button>
            </div>
          </div>
        </Modal>

        <Modal
          open={this.state.openPassengersModal}
          onClose={this.handleClosePassengersModal}
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <div
            style={{
              background: "white",
              borderRadius: 8,
              padding: 20,
              width: "65%",
              maxHeight: "auto",
              overflowY: "auto",
              boxShadow: "0 4px 20px rgba(0, 0, 0, 0.2)",
            }}
          >
            <p
              style={{
                margin: 6,
                fontSize: 18,
              }}
            >
              Passageiros de {this.state.missionName}
            </p>
            <br></br>
            {(this.state.currentStage.passengers || []).length > 0 ? (
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell></TableCell>
                    <TableCell>NOME</TableCell>
                    <TableCell>EMAIL</TableCell>
                    <TableCell>CPF</TableCell>
                    <TableCell>TELEFONE</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {this.state.currentStage.passengers.map(
                    (passenger, index) => (
                      <TableRow key={index}>
                        <TableCell>{index + 1}</TableCell>
                        <TableCell>
                          {passenger.first_name} {passenger.last_name}
                        </TableCell>
                        <TableCell>{passenger.email}</TableCell>
                        <TableCell>{passenger.cpf}</TableCell>
                        <TableCell>{passenger.phone}</TableCell>
                      </TableRow>
                    )
                  )}
                </TableBody>
              </Table>
            ) : (
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  height: "100%",
                  width: "100%",
                  fontSize: "16px",
                  textAlign: "center",
                  color: "gray",
                }}
              >
                Nenhum passageiro selecionado.
              </div>
            )}

            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                marginTop: 16,
              }}
            >
              <Button
                onClick={this.handleClosePassengersModal}
                color="secondary"
              >
                Fechar
              </Button>
            </div>
          </div>
        </Modal>
      </div>
    );
  }
}

const tableStyle = { fontWeight: "bold", fontSize: 14 };

const mapStateToProps = (state) => ({
  user: state.authReducer.user,
});

const mapDispatchToProps = {
  navigate,
  msgSimple,
};

export default connect(mapStateToProps, mapDispatchToProps)(ModalStatus);



// WEBPACK FOOTER //
// ./src/routes/home/ModalStatus.js